<script>
import toggleModal from '@/mixins/toggleModal';
import { mapActions, mapState } from 'vuex';
import { CloseOutlined } from '@ant-design/icons-vue';
import bem from '@/utils/bem';

const b = bem('faq-form-modal');

export default {
  components: { CloseOutlined },
  mixins: [toggleModal],
  props: {
    changeableFAQ: Object,
    parentChangeableFAQ: Object,
  },
  data() {
    return {
      isShowVariablePopUp: false,
      descriptionMobile: '',
      changeableTitle: '',
      changeableTitleMobile: '',
      changeableDescription: '',
      changeableDescriptionMobile: '',
      changeableId: '',
      changeableIsCategory: false,
      variablePopUpNode: null,
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      createFAQ: 'faq/createFAQ',
      editFAQ: 'faq/editFAQ',
    }),
    onCancel() {
      this.hideModal();
      this.$emit('update:clearChangeableFAQ', null);
      this.$emit('update:parentChangeableFAQ', null);
    },
    onSubmit(value) {
      this.onCancel();
      return this.changeableId ? (
        this.editFAQ({
          body: {
            ...value,
            isCategory: this.changeableIsCategory,
          },
          id: this.changeableFAQ.id,
          path: this.parentChangeableFAQ.page || this.currentFAQPage.page,
        })
      ) : (
        this.createFAQ({
          body: {
            ...value,
            isCategory: this.changeableIsCategory,
            parentId: this.parentChangeableFAQ.id || this.currentFAQPage.id,
            page: this.parentChangeableFAQ.page || this.currentFAQPage.page,
          },
          path: this.parentChangeableFAQ.page || this.currentFAQPage.page,
        })
      );
    },
    onSubmitForm(formName) {
      this.$formkit.submit(formName);
    },
    onChangeText(value, event) {
      const isParent = Boolean(this.changeableId && !this.changeableFAQ.parentId);
      if (value.length >= 2) {
        const subString = value.substr(value.length - 2);
        if (subString === '[[' && !isParent) {
          this.variablePopUpNode = event.context.node;
          this.isShowVariablePopUp = true;
        }
      }
    },
    resetVariablePopUp() {
      this.$formkit.reset('variableLink');
      this.isShowVariablePopUp = false;
      this.variablePopUpNode = null;
    },
    onCloseVariableLink() {
      this.variablePopUpNode.input(this.variablePopUpNode.value.slice(0, -2));
      this.resetVariablePopUp();
    },
    onSaveVariableLink(value) {
      const {
        variableLinkUrl,
        variableLinkText,
      } = value;
      this.variablePopUpNode.input(
        `${this.variablePopUpNode.value}${variableLinkUrl}|${variableLinkText}]]`,
      );
      this.resetVariablePopUp();
    },
    getDescription(description) {
      return description.split('[[').reduce((acc, item) => {
        const [substring = '', continueText = ''] = item.split(']]');
        const [link = '', linkText = ''] = substring.split('|');
        return `${acc}<a href=${link} target="_blank">${linkText}</a>${continueText}`;
      });
    },
    handleChangeTemplate(template) {
      this.changeableTitle = template.title;
      this.changeableTitleMobile = template.titleMobile;
      this.changeableDescription = template.description;
      this.changeableDescriptionMobile = template.descriptionMobile;
    },
  },
  watch: {
    changeableFAQ: {
      handler(newValue) {
        this.changeableTitle = newValue?.title || '';
        this.changeableTitleMobile = newValue?.titleMobile || '';
        this.changeableDescription = newValue?.description || '';
        this.changeableDescriptionMobile = newValue?.descriptionMobile || '';
        this.changeableIsCategory = newValue?.isCategory || false;
        this.changeableId = newValue?.id || '';
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      currentFAQPage: (state) => state.faq.faqPage,
      faqTemplates: (state) => state.faq.faqTemplates,
    }),
    inputTexts() {
      const isParent = Boolean(this.changeableId && !this.changeableFAQ.parentId);
      let titleLabel = '';
      let descriptionLabel = '';
      if (isParent) {
        titleLabel = 'Title';
        descriptionLabel = 'Description';
      } else if (this.changeableIsCategory) {
        titleLabel = 'Category Name';
        descriptionLabel = '';
      } else {
        titleLabel = 'Question';
        descriptionLabel = 'Answer';
      }

      return {
        titleLabel,
        titlePlaceholder: `Enter ${titleLabel}`,
        descriptionLabel,
        descriptionPlaceholder: `Enter ${descriptionLabel}`,
        mobTitleLabel: `Mobile ${titleLabel}`,
        mobTitlePlaceholder: `Enter Mobile ${titleLabel}`,
        mobDescriptionLabel: `Mobile ${descriptionLabel}`,
        mobDescriptionPlaceholder: `Enter Mobile ${descriptionLabel}`,
        descriptionHelp: isParent ? '' : 'Enter [[ to add a link. To delete a link, erase everything from [[ to ]]',
      };
    },
    previewText() {
      return this.getDescription(this.changeableDescription);
    },
    mobilePreviewText() {
      return this.getDescription(this.changeableDescriptionMobile);
    },
  },
};
</script>

<template>
  <a-modal
    :open="show"
    :footer="null"
    :closable="false"
    width="fit-content"
  >
    <FormKit
      type="form"
      id="faqParent"
      @submit="onSubmit"
      :actions="false"
      :form-class="b('')"
    >
      <a-button
        type="primary"
        danger
        :class="b('close-editor-wrapper')"
        shape="circle"
        size="small"
        @click="onCancel"
      >
        <CloseOutlined/>
      </a-button>
      <a-select
        placeholder="Select template"
        style="width: 350px"
        :options="faqTemplates.map((item) => ({ label: item.name, value: item }))"
        @select="handleChangeTemplate"
        v-if="(!changeableIsCategory && (!this.changeableFAQ || this.changeableFAQ.parentId))"
      />
      <div :class="b('row')">
        <div :class="b('column')">
          <FormKit
            type="text"
            name="title"
            v-model="changeableTitle"
            :label="inputTexts.titleLabel"
            :placeholder="inputTexts.titlePlaceholder"
            validation="required"
            :classes="{
              wrapper: b('input-form-wrapper'),
            }"
          />
          <FormKit
            v-if="!changeableIsCategory"
            type="textarea"
            name="description"
            v-model="changeableDescription"
            id="descriptionMobileForm"
            @input="onChangeText"
            :help="inputTexts.descriptionHelp"
            :label="inputTexts.descriptionLabel"
            :placeholder="inputTexts.descriptionPlaceholder"
            validation="required"
            :classes="{
              wrapper: b('input-form-wrapper'),
            }"
          />
          <div
            :class="b('preview-wrapper', {isCategory: changeableIsCategory})"
            v-if="
              (previewText || changeableTitle)
              && (!this.changeableFAQ || this.changeableFAQ.parentId || changeableIsCategory)
            "
          >
            <span :class="b('preview-title', {isCategory: changeableIsCategory})">
              {{ changeableTitle }}
            </span>
            <div
              :class="b('preview', {isCategory: changeableIsCategory})"
              v-if="!changeableIsCategory"
              v-html="previewText"
            />
          </div>
        </div>
        <div :class="b('column')">
          <FormKit
            type="text"
            name="titleMobile"
            v-model="changeableTitleMobile"
            :label="inputTexts.mobTitleLabel"
            :placeholder="inputTexts.mobTitlePlaceholder"
            :classes="{
              wrapper: b('input-form-wrapper'),
            }"
          />
          <FormKit
            v-if="!changeableIsCategory"
            type="textarea"
            name="descriptionMobile"
            v-model="changeableDescriptionMobile"
            id="descriptionMobileForm"
            @input="onChangeText"
            :help="inputTexts.descriptionHelp"
            :label="inputTexts.mobDescriptionLabel"
            :placeholder="inputTexts.mobDescriptionPlaceholder"
            :classes="{
              wrapper: b('input-form-wrapper'),
            }"
          />
          <div
            :class="b('preview-wrapper', {isCategory: changeableIsCategory})"
            v-if="
              (mobilePreviewText || changeableTitleMobile)
              && (!this.changeableFAQ || this.changeableFAQ.parentId || changeableIsCategory)
            "
          >
            <span :class="b('preview-title', {isCategory: changeableIsCategory})">
              {{ changeableTitleMobile }}
            </span>
            <div
              v-if="!changeableIsCategory"
              :class="b('preview', {isCategory: changeableIsCategory})"
              v-html="mobilePreviewText"
            />
          </div>
        </div>
      </div>
      <a-button
        :class="b('submit-button')"
        @click="() => onSubmitForm('faqParent')"
        type="primary"
        size="large"
      >
        {{ changeableFAQ?.id ? "Save" :  "Create" }}
      </a-button>
    </FormKit>
  </a-modal>
  <a-modal
    :open="isShowVariablePopUp"
    @cancel="onCloseVariableLink"
    :closable="false"
    @ok="() => onSubmitForm('variableLink')"
  >
    <FormKit
      type="form"
      id="variableLink"
      @submit="onSaveVariableLink"
      :actions="false"
      :form-class="b('')"
    >
      <FormKit
        type="text"
        name="variableLinkUrl"
        label="Link URL"
        placeholder="Enter link url"
        validation="required"
        :classes="{
          wrapper: b('input-form-wrapper'),
        }"
      />
      <FormKit
        type="text"
        name="variableLinkText"
        label="Link TEXT"
        placeholder="Enter link text"
        validation="required"
        :classes="{
          wrapper: b('input-form-wrapper'),
        }"
      />
    </FormKit>
  </a-modal>

</template>

<style lang="scss">
  @import "@/styles/media";
  @import "@/styles/variables";

  .faq-form-modal {
    display: flex;
    flex-direction: column;
    min-height: fit-content;
    padding: 20px 40px;
    gap: 30px;
    width: fit-content;

    @include mediaMinMax(1025, $normal) {
      padding: vw-full(20) vw-full(40);
      gap: vw-full(30);
    }

    &__close-editor-wrapper {
      margin-left: auto;
    }

    &__row {
      display: flex;
      gap: 70px;

      @include mediaMinMax(1025, $normal) {
        gap: vw-full(70);
      }
    }

    &__column {
      display: flex;
      flex-direction: column;
      gap: 20px;
      @include mediaMinMax(1025, $normal) {
        gap: vw-full(20);
      }
    }

    &__preview-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      max-width: 350px;
      box-shadow: 10.1px 12.4px 76px 0 rgba(0, 0, 0, 0.07);
      background-color: #fff;

      @include mediaMinMax(1025, $normal) {
        max-width: vw-full(350);
      }

      &_isCategory {

      }
    }

    &__preview-title {
      padding: 5px;
      font-size: 14px;
      width: 100%;
      display: block;

      &_isCategory {
        background-color: $jagged-ice;
        color: $horizon;
        text-transform: uppercase;
      }
    }

    &__preview {
      padding: 5px;
      color: $main-gray-color;

      &_isCategory {
        color: $ebony-clay-gray-color;
      }
    }

    &__input-form-wrapper {
      min-width: 300px;

      @include mediaMinMax(1025, $normal) {
        min-width: vw-full(300);
      }
    }

    &__submit-button {
      width: fit-content;
      min-width: 100px;
      align-self: flex-end;

      @include mediaMinMax(1025, $normal) {
        min-width: vw-full(100);
      }
    }
  }
</style>
